"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChallengeRankingGroupingConfig = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getChallengeRankingGroupingConfig = function getChallengeRankingGroupingConfig(_ref) {
  var groupingName = _ref.groupingName,
      userParentGroupId = _ref.userParentGroupId,
      subGroupId = _ref.subGroupId,
      challengeId = _ref.challengeId;
  var topParentFilter = {
    topParentChallenge: userParentGroupId
  };
  var subGroupIdFilter = {
    groupChallenge: subGroupId
  };
  var userFilter = subGroupId ? subGroupIdFilter : topParentFilter;
  var groupingConfig = {
    groupsTopParent: {
      rankingType: 'groups',
      subgroup: false,
      challengeId: challengeId
    },
    groupsChildren: {
      rankingType: 'groups',
      topParentChallenge: userParentGroupId,
      challengeId: challengeId,
      subgroup: true
    },
    allGroupsChildren: {
      rankingType: 'groups',
      subgroup: true,
      challengeId: challengeId
    },
    users: _objectSpread({
      rankingType: 'users',
      challengeId: challengeId
    }, userFilter),
    allUsers: {
      rankingType: 'users',
      challengeId: challengeId
    },
    crossGroupUsers: _objectSpread({
      rankingType: 'users',
      challengeId: challengeId
    }, topParentFilter)
  };
  return groupingConfig[groupingName];
};

exports.getChallengeRankingGroupingConfig = getChallengeRankingGroupingConfig;
//# sourceMappingURL=challengeRankingGroupingFilters.js.map